import { render } from "./component-receiver-bik.vue?vue&type=template&id=030de75a"
import script from "./component-receiver-bik.vue?vue&type=script&setup=true&lang=js"
export * from "./component-receiver-bik.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-receiver-bik.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "030de75a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('030de75a', __exports__)) {
    api.reload('030de75a', __exports__)
  }
  
  module.hot.accept("./component-receiver-bik.vue?vue&type=template&id=030de75a", () => {
    api.rerender('030de75a', render)
  })

}


export default __exports__